import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import posthog from 'posthog-js';

import App from './App.vue';
import router from './router';

import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import '@/assets/styles.scss';
import '@/assets/tailwind.css';

posthog.init(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN || '', {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    defaults: '2026-01-30',
    // Only capture in production, mirroring the gtag conversion gating in
    // composables/googleAds.js: local/staging signups were polluting funnel
    // metrics in the production PostHog project (SHOA-168). Initializing
    // opted-out (rather than skipping init) keeps posthog.* calls throughout
    // the app safe no-ops in non-prod.
    opt_out_capturing_by_default: import.meta.env.VITE_ENVIRONMENT !== 'production',
});

const app = createApp(App);

if (import.meta.env.VITE_ENVIRONMENT && import.meta.env.VITE_ENVIRONMENT !== 'local') {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_ENVIRONMENT,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
        ],
        tracesSampleRate: 0,
    });
}

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
});
app.use(ToastService);
app.use(ConfirmationService);

app.config.errorHandler = (err, instance, info) => {
    Sentry.captureException(err);
    posthog.captureException(err);
};

app.mount('#app');
